module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Ressource.ba9bdd24-ps.jpg";